import { render, staticRenderFns } from "./IdRecode.vue?vue&type=template&id=41fd3338&scoped=true&"
import script from "./IdRecode.vue?vue&type=script&lang=js&"
export * from "./IdRecode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fd3338",
  null
  
)

export default component.exports